import { useEffect } from 'react';
import { useFramework } from '@/framework';
import type { ILayerProps } from '@/version-types';
import { HIERARCHY_EVENTS } from '../../hierarchy/constants';
import type { StageToolbar } from '../../stage-toolbar';

export const HierarchyActionBridge = ({ toolbar }: { toolbar: StageToolbar }) => {
    const framework = useFramework();

    useEffect(() => {
        // 图层 View 继续使用内部事件解耦操作；这里只映射为公开类型化 action，不向消费者暴露事件名。
        const operationListener = framework.service.events.on(
            HIERARCHY_EVENTS.LAYER_OPERATION,
            (layer: ILayerProps, operation: string) => {
                toolbar.emitAction({ type: 'hierarchy-operation', layer, operation });
            },
        );
        const selectListener = framework.service.events.on(HIERARCHY_EVENTS.SELECT_MANUAL, (layer: ILayerProps) => {
            toolbar.emitAction({ type: 'hierarchy-select', layer });
        });

        return () => {
            framework.service.events.off(operationListener);
            framework.service.events.off(selectListener);
        };
    }, [framework, toolbar]);

    return null;
};
